









































import {
  defineComponent,
  SetupContext,
  reactive,
  ref,
  watch,
  computed,
} from '@vue/composition-api'

import { IRecommend } from '@/types/recommend'
import { IItem } from '@/types/receipt'

import { autoCompleteFilter } from '@/utils/kanaToHira'

type Props = {
  list: IRecommend[]
  input: string
  categoryId: number
  item: IItem
}

export default defineComponent({
  name: 'MasterAutocomplete',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    input: {
      type: String,
      default: '',
    },
    categoryId: {
      type: Number,
      default: -1,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context: SetupContext) {
    const state = reactive<{
      searchInput: string | null
    }>({
      searchInput: '',
    })

    const autocomplete = ref<any>(null)

    const generateModel = (item: IItem): IRecommend | null => {
      return item.matchedCode && item.matchedName
        ? {
            id: '',
            name: item.matchedName,
            code: item.matchedCode,
            price: Number(item.price || 0),
            category: '',
            isMatched: false,
            isToBeDeleted: false,
            _score: 0,
            pbChainStoreIds: null,
          }
        : null
    }
    const model = ref<IRecommend | null>(generateModel(props.item))
    watch(
      () => props.item,
      () => {
        model.value = generateModel(props.item)
      },
    )

    const placeholder = computed<string>(() => {
      return props.input
    })

    const isMatched = computed<boolean>(() => {
      return props.item.autoMatchedAt !== null && props.item.isMatched === true
    })

    const onSelect = (recommend?: IRecommend) => {
      if (recommend !== undefined) {
        context.emit('select', recommend)
      }
    }

    const focus = () => {
      context.emit('focus')
      autocomplete.value.activateMenu()
    }

    const onFocus = () => {
      // placeholderからsearchInputを復帰
      // searchInput か item.name が存在すれば search
      state.searchInput = placeholder.value
      if (state.searchInput.length > 0) {
        // @todo 必要？
        // context.emit('exec-recommend-search', state.searchInput)
      }
      focus()
    }

    const onBlur = (e: any) => {
      context.emit('blur')
      if (e.sourceCapabilities === null) {
        // マスタから選択時直後のイベントを無効化
        return
      }
      if (model.value && e.target.value !== model.value.name) {
        context.emit('unselect')
      }
    }

    const onKeyDown = async (e: any) => {
      // 以下は実験敵にCtrl+Enterに移行中
      // if (e.code === 'Enter' && e.key === 'Enter') {
      //   return
      // }
      if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
        console.info('Arrow', e.code)
        return
      }
      if (e.isComposing === true && e.code !== 'Enter') {
        console.info('isComposing not Enter', e.code)
        return
      }
      // 以下実験中
      if (e.code === 'Backspace' || e.target.value.length < 3) {
        console.info('Backspace or short', e.code, e.target.value)
        context.emit('unselect')
        context.emit('clear-recommend-list')
      }
      if (e.target.value.length === 0) {
        console.info('Too short', e.code, e.target.value)
        return
      }
      if (e.code === 'Enter' && e.key === 'Enter') {
        console.info('Enter', e.code, e.key)
        if (e.ctrlKey || e.metaKey) {
          console.info('CtrlKey', e.ctrlKey, e.metaKey, e.target.value)
          context.emit('exec-recommend-search', e.target.value)
        } else {
          console.info('No ctrlKey', e.ctrlKey, e.metaKey, e.target.value)
          return
        }
      }
      console.info('Other', e.code)
      // focus()
    }

    const onMouseUp = (_e: any) => {
      state.searchInput = placeholder.value
      focus()
    }

    const onUpdateSearchInput = (searchInput: string | null) => {
      // search-input.sync を override
      if (searchInput !== null) {
        state.searchInput = searchInput
        context.emit('update:input', searchInput)
      }
    }

    return {
      state,
      placeholder,
      autocomplete,
      isMatched,
      model,
      onSelect,
      onKeyDown,
      onMouseUp,
      onFocus,
      onBlur,
      onUpdateSearchInput,
      autoCompleteFilter,
    }
  },
})
